// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","accent":"#BFD730","heading":"_3ISX","content":"HKbd","negativeMargin":"_2Qaj","item":"_2bsf","tag":"_22q6","add":"YJ1V","filter-row":"_20lt","subscribe":"BvUI","subscribe-button":"_21yh"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Blog/BlogIndex/BlogIndex.scss
// module id = vbEo
// module chunks = 0